import React from 'react';
import LegalPageTemplate from './LegalPageTemplate';
import { useLanguage } from '../../hooks/useLanguage';

const CookiePolicy: React.FC = () => {
    const { t, isRTL } = useLanguage();

    return (
        <LegalPageTemplate
            title={t('cookiePolicy.title')}
            lastUpdated={t('cookiePolicy.lastUpdated')}
        >
            <div dir={isRTL ? 'rtl' : 'ltr'}>
                <p className={`text-gray-600 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.intro')}
                </p>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section1.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section1.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section1.paragraph2')}
                </p>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section2.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section2.intro')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section2.subsection1.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section2.subsection1.description')}
                </p>
                <table className="min-w-full mt-2 border-collapse border border-gray-300">
                    <thead>
                    <tr className="bg-gray-100">
                        <th className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.table.cookieName')}
                        </th>
                        <th className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.table.purpose')}
                        </th>
                        <th className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.table.duration')}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="border border-gray-300 px-4 py-2">sessionId</td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.cookies.sessionId')}
                        </td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.duration.session')}
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-300 px-4 py-2">auth_token</td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.cookies.authToken')}
                        </td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.duration.30days')}
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-300 px-4 py-2">XSRF-TOKEN</td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.cookies.xsrfToken')}
                        </td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.duration.session')}
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section2.subsection2.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section2.subsection2.description')}
                </p>
                <table className="min-w-full mt-2 border-collapse border border-gray-300">
                    <thead>
                    <tr className="bg-gray-100">
                        <th className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.table.cookieName')}
                        </th>
                        <th className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.table.purpose')}
                        </th>
                        <th className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.table.duration')}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="border border-gray-300 px-4 py-2">_ga</td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.cookies.ga')}
                        </td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.duration.2years')}
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-300 px-4 py-2">_gid</td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.cookies.gid')}
                        </td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.duration.24hours')}
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-300 px-4 py-2">_gat</td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.cookies.gat')}
                        </td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.duration.1minute')}
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section2.subsection3.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section2.subsection3.description')}
                </p>
                <table className="min-w-full mt-2 border-collapse border border-gray-300">
                    <thead>
                    <tr className="bg-gray-100">
                        <th className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.table.cookieName')}
                        </th>
                        <th className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.table.purpose')}
                        </th>
                        <th className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.table.duration')}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="border border-gray-300 px-4 py-2">language</td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.cookies.language')}
                        </td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.duration.1year')}
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-300 px-4 py-2">theme</td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.cookies.theme')}
                        </td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.duration.1year')}
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section2.subsection4.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section2.subsection4.description')}
                </p>
                <table className="min-w-full mt-2 border-collapse border border-gray-300">
                    <thead>
                    <tr className="bg-gray-100">
                        <th className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.table.cookieName')}
                        </th>
                        <th className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.table.purpose')}
                        </th>
                        <th className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.table.duration')}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="border border-gray-300 px-4 py-2">_fbp</td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.cookies.fbp')}
                        </td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.duration.3months')}
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-300 px-4 py-2">fr</td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.cookies.fr')}
                        </td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.duration.3months')}
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-300 px-4 py-2">IDE</td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.cookies.ide')}
                        </td>
                        <td className={`border border-gray-300 px-4 py-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                            {t('cookiePolicy.duration.1year')}
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section3.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section3.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section3.paragraph2')}
                </p>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li><strong>{t('cookiePolicy.section3.list.banner.title')}</strong> {t('cookiePolicy.section3.list.banner.text')}</li>
                    <li><strong>{t('cookiePolicy.section3.list.browser.title')}</strong> {t('cookiePolicy.section3.list.browser.text')}</li>
                </ul>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-10 text-right' : 'pl-10 text-left'}`}>
                    <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#115DF2] hover:underline">Google Chrome</a></li>
                    <li><a href="https://support.mozilla.org/fr/kb/cookies-informations-sites-enregistrent" target="_blank" rel="noopener noreferrer" className="text-[#115DF2] hover:underline">Mozilla Firefox</a></li>
                    <li><a href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#115DF2] hover:underline">Safari</a></li>
                    <li><a href="https://support.microsoft.com/fr-fr/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank" rel="noopener noreferrer" className="text-[#115DF2] hover:underline">Internet Explorer</a></li>
                    <li><a href="https://support.microsoft.com/fr-fr/microsoft-edge/supprimer-les-cookies-dans-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-[#115DF2] hover:underline">Microsoft Edge</a></li>
                </ul>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section4.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section4.intro')}
                </p>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li><strong>{t('cookiePolicy.section4.list.pixels.title')}</strong> {t('cookiePolicy.section4.list.pixels.text')}</li>
                    <li><strong>{t('cookiePolicy.section4.list.storage.title')}</strong> {t('cookiePolicy.section4.list.storage.text')}</li>
                    <li><strong>{t('cookiePolicy.section4.list.sdk.title')}</strong> {t('cookiePolicy.section4.list.sdk.text')}</li>
                </ul>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section4.conclusion')}
                </p>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section5.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section5.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section5.paragraph2')}
                </p>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section6.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section6.intro')}
                </p>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('cookiePolicy.section6.email')}</li>
                </ul>

                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section7.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section7.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('cookiePolicy.section7.paragraph2')}
                </p>
            </div>
        </LegalPageTemplate>
    );
};

export default CookiePolicy;